export default ({ size, color = '#000' } = {}) =>`
  <svg xmlns='http://www.w3.org/2000/svg' width="${ size }" height="${ size }" viewBox='0 0 24 24' stroke-width='2' stroke='currentColor' fill='none' stroke-linecap='round' stroke-linejoin='round'>
    <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
    <rect x='6' y='5' width='4' height='14' rx='1' fill="${ color }"></rect>
    <rect x='14' y='5' width='4' height='14' rx='1' fill="${ color }"></rect>
  </svg>
`
